import { useState } from "react";
import { ClubCart } from "../../../../models/ClubCart";
import { GET_CLUB_CART_DETAILS } from "../../../../api/apiRoutes";
import useApiRequest from "../../../../../utils/hooks/useApiRequest";
import useFacility from "../../../../../utils/hooks/useFacility";

export default function useClubCart() {
  const facilityIds = useFacility();
  const { get } = useApiRequest();
  const [loading, setLoading] = useState(false);
  const [clubCarnetDetails, setClubCarnetDetails] = useState<ClubCart>();


  const getClubCartDetails = async (assortIds: string) =>  {
    setLoading(true);
    const { result, isError } = await get(
      GET_CLUB_CART_DETAILS(
        facilityIds,
        assortIds 
      )
    );
    if (!isError) {
      setClubCarnetDetails(result);
    }
    setLoading(false);
  }


  return {
    loading,
    getClubCartDetails,
    clubCarnetDetails,
  };
}
